export default {
  blue: ({ disabled }) => {
    let bg = 'primary.default';
    let textColor = 'white';
    if (disabled) {
      bg = 'gray.150';
      textColor = 'gray.400';
    }
    return ({
      borderRadius: '5px',
      bg: `${bg}`,
      color: `${textColor}`,
      _hover: !disabled && { bg: 'primary.700' },
      _active: !disabled && { bg: 'primary.900' },
    });
  },
  teal: ({ disabled }) => {
    let bg = 'secondary.default';
    let textColor = 'white';
    if (disabled) {
      bg = 'gray.150';
      textColor = 'gray.400';
    }
    return ({
      borderRadius: '5px',
      bg: `${bg}`,
      color: `${textColor}`,
      _hover: !disabled && { bg: 'secondary.700' },
      _active: !disabled && { bg: 'secondary.1000' },
    });
  },
};
